/* tslint:disable:max-line-length */
import { FuseNavigationItem } from "@fuse/components/navigation";

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "basic",
    icon: "heroicons_outline:view-grid",
    link: "/profile-dashboard",
  },
  {
    id: "profile",
    title: "Profile",
    type: "basic",
    icon: "heroicons_outline:user-circle",
    link: "/profile-detail",
  },
  {
    id: "organization",
    title: "My Organization",
    type: "basic",
    icon: "heroicons_outline:office-building",
    link: "/organization",
  },
  {
    id: "add-program",
    title: "Program",
    type: "basic",
    icon: "heroicons_outline:plus-circle",
    link: "/program-list",
  },
  {
    id: "attendance",
    title: "Attendance",
    type: "basic",
    icon: "heroicons_outline:clipboard-check",
    link: "/attendance",
  },
  {
    id: "reports",
    title: "Reports",
    type: "basic",
    icon: "heroicons_outline:document-report",
    link: "/reports",
  },
  {
    id: "add-community",
    title: "List of Communities",
    type: "basic",
    icon: "heroicons_outline:map",
    link: "/community-list",
  },
];

export const compactNavigation: FuseNavigationItem[] = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "basic",
    icon: "heroicons_outline:view-grid",
    link: "/profile-dashboard",
  },
  {
    id: "profile",
    title: "Profile",
    type: "basic",
    icon: "heroicons_outline:user-circle",
    link: "/profile-detail",
  },
  {
    id: "attendance",
    title: "Attendance",
    type: "basic",
    icon: "heroicons_outline:clipboard-check",
    link: "/attendance",
  },
  {
    id: "reports",
    title: "Reports",
    type: "basic",
    icon: "heroicons_outline:document-report",
    link: "/reports",
  },
  {
    id: "add-program",
    title: "Program",
    type: "basic",
    icon: "heroicons_outline:plus-circle",
    link: "/program-list",
  },
  {
    id: "add-community",
    title: "List of Communities",
    type: "basic",
    icon: "heroicons_outline:office-building",
    link: "/community-list",
  },
];

export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "basic",
    icon: "heroicons_outline:view-grid",
    link: "/profile-dashboard",
  },
  {
    id: "profile",
    title: "Profile",
    type: "basic",
    icon: "heroicons_outline:user-circle",
    link: "/profile-detail",
  },
  {
    id: "attendance",
    title: "Attendance",
    type: "basic",
    icon: "heroicons_outline:clipboard-check",
    link: "/attendance",
  },
  {
    id: "reports",
    title: "Reports",
    type: "basic",
    icon: "heroicons_outline:document-report",
    link: "/reports",
  },
  {
    id: "add-program",
    title: "Program",
    type: "basic",
    icon: "heroicons_outline:plus-circle",
    link: "/program-list",
  },
  {
    id: "add-community",
    title: "List of Communities",
    type: "basic",
    icon: "heroicons_outline:office-building",
    link: "/community-list",
  },
];

export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "basic",
    icon: "heroicons_outline:view-grid",
    link: "/profile-dashboard",
  },
  {
    id: "profile",
    title: "Profile",
    type: "basic",
    icon: "heroicons_outline:user-circle",
    link: "/profile-detail",
  },
  {
    id: "attendance",
    title: "Attendance",
    type: "basic",
    icon: "heroicons_outline:clipboard-check",
    link: "/attendance",
  },
  {
    id: "reports",
    title: "Reports",
    type: "basic",
    icon: "heroicons_outline:document-report",
    link: "/reports",
  },
  {
    id: "add-program",
    title: "Program",
    type: "basic",
    icon: "heroicons_outline:plus-circle",
    link: "/program-list",
  },
  {
    id: "add-community",
    title: "List of Communities",
    type: "basic",
    icon: "heroicons_outline:office-building",
    link: "/community-list",
  },
];
